import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import groupDetails from './groupDetails'
import searchDetails from './searchDetails'
import flightOffers from './flightOffers'
import ancillaries from './ancillaries'
import bookerDetails from './bookerDetails'
import validation from './validation'
import submitting from './submitting'
import airports from './airports'
import content from './content'

export default history =>
  combineReducers({
    router: connectRouter(history),
    groupDetails,
    validation,
    searchDetails,
    flightOffers,
    ancillaries,
    bookerDetails,
    submitting,
    airports,
    content,
  })
